import script from "./SchoolDaySIS.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolDaySIS.vue?vue&type=script&setup=true&lang=ts"

import "./SchoolDaySIS.vue?vue&type=style&index=0&id=3f854d58&lang=css"

const __exports__ = script;

export default __exports__